import { gql, type TypedDocumentNode } from "@apollo/client";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";
import type { CRMNote } from "@/types";
import type { GovernanceTitle, PersonGovernanceFacility } from "./types";

export interface PersonFacilityGovernanceRoleNode {
  id: string;
  status: string;
  title: GovernanceTitle;
  facility: PersonGovernanceFacility;
  notes: CRMNote[];
}

export interface PersonFacilityGovernanceRolesQueryData {
  person: {
    id: string;
    facilityGovernanceRoles: PersonFacilityGovernanceRoleNode[];
  };
}

export interface PersonFacilityGovernanceRolesQueryVariables {
  pgaId: string;
}

export const PERSON_FACILITY_GOVERNANCE_ROLES_QUERY: TypedDocumentNode<
  PersonFacilityGovernanceRolesQueryData,
  PersonFacilityGovernanceRolesQueryVariables
> = gql`
  query PersonFacilityGovernanceRoles($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      facilityGovernanceRoles {
        id
        status
        title {
          id
          title
        }
        facility {
          id
          name
          legacyId
          section {
            id
            name
          }
        }
        notes {
          ...CRMNoteFields
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;
